jQuery.fn.readMore = function() {
  let self = this

  self.children().wrapAll("<div class='read-more__wrapper'></div>").wrapAll("<div class='read-more__height-ruler text-content'></div>");

  button = $('<button class="btn-primary read-more__button"><span class="read-more__more">Lire plus</span><span class="read-more__less">Lire moins</span></button>');

  if ($('html').attr('lang') == 'en-US' || $('html').attr('lang') == 'en-CA') {
    button.find('.read-more__more').html('Read more');
    button.find('.read-more__less').html('Read less');
  }

  button.click(function() {
    self.css('--max-height', self.find('.read-more__height-ruler').outerHeight() + 'px');
    self.toggleClass('read-more--extended')
    if (self.hasClass('read-more--extended')) {
      self.removeClass('read-more--closed')
    } else {
      self.addClass('read-more--closed')
    }
  });

  self.append(button);
  self.addClass('read-more');

  self.check = function () {
    self.removeClass('read-more--extended');
    self.removeClass('read-more--closed');
    if (self.find('.read-more__height-ruler').outerHeight() > self.find('.read-more__wrapper').outerHeight()) {
      self.removeClass('disabled')
    } else {
      self.addClass('disabled')
    }
  }

  return function() {
    $(window).on('resize orientationchange load', self.check)
    return self
  }()
};
